import { trackClientEvent } from '../../../../../trackClientEvent';
export const eventKey = 'hotjar_config-failed_to_initialize-action_unknown';
/**
 * Failed to initialize hotjar
 */
export function trackHotjarConfigFailedToInitialize() {
    return trackClientEvent({
        eventKey,
        realTimeTracking: false,
    });
}
